import { Grid, TextField } from "@mui/material"
import { useState } from "react"
import Modal from "../ui/Modal"

const initialData = {
  qualification: "",
  specilisation: "",
  institutionName: "",
  passingYear: "",
  grade: "",
}

const AddQualification = (props) => {
  const [data, setData] = useState(initialData)
  const handleChange = (e) => {
    const { name, value } = e.target
    setData({
      ...data,
      [name]: value,
    })
  }
  const action = () => {
    props.add(data)
    setData(initialData)
    props.close()
  }
  return (
    <Modal
      {...props}
      title="Add Qualification"
      actionText={"Add"}
      action={action}
    >
      <Grid container spacing={2} mt={1}>
        <Grid item xs={6}>
          <TextField
            fullWidth
            label="Degree/Qualification"
            name="qualification"
            value={data.qualification}
            onChange={handleChange}
          />
        </Grid>
        <Grid item xs={6}>
          <TextField
            fullWidth
            label="Specilisation (if any)"
            name="specilisation"
            value={data.specilisation}
            onChange={handleChange}
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            fullWidth
            label="Institute/College/School Name"
            name="institutionName"
            value={data.institutionName}
            onChange={handleChange}
          />
        </Grid>
        <Grid item xs={6}>
          <TextField
            fullWidth
            label="Passing Year"
            name="passingYear"
            value={data.passingYear}
            onChange={handleChange}
          />
        </Grid>
        <Grid item xs={6}>
          <TextField
            fullWidth
            label="Grade/Percentage"
            name="grade"
            value={data.grade}
            onChange={handleChange}
          />
        </Grid>
      </Grid>
    </Modal>
  )
}

export default AddQualification
